<template>
  <!-- <ScreenAdapter>
  </ScreenAdapter> -->
  <div class="fff">
    <Aside></Aside>
    <Header />
    <div class="container">
      <div class="theory-content" v-if="xsdxsxData&&xsdxsxData.length>0">
        <div class="content-header" ref="223">
          <div class="text">新时代 新思想</div>
        </div>
        <div class="content-box">
          <div class="show-cover" @click="jumpDetail(xsdxsxData[swiperActive])">
            <div class="c-img" :style="`background:url(${xsdxsxData[swiperActive].photo}) no-repeat center/cover;`"></div>
          </div>
          <div class="swiper">
            <swiper :options="swiperOption">
              <swiper-slide v-for="item,index in xsdxsxData" :key="index" :data-index="index" :data-id="item.id">
                <div class="img" :data-id="item.id" :class="[swiperActive == index ? 'active':'']">
                  <div class="cover c-img" :data-id="item.id" :style="`background:url(${item.photo}) no-repeat center/cover;`"></div>
                </div>
              </swiper-slide>
            </swiper>
            <div class="t swiper-button-next">
              <div class="arrow"></div>
            </div>
            <div class="t swiper-button-prev">
              <div class="arrow"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="history-content" v-if="esdxzcData&&esdxzcData.length>0">
        <div class="content-header" ref="224">
          <div class="text">二十大 新征程</div>
        </div>
        <div class="content-box">
          <div class="swiper">
            <swiper :options="swiperOption2">
              <swiper-slide v-for="item,index in esdxzcData.slice(0,4)" :key="index">
                <div class="cover" :style="`background:url(${item.photo}) no-repeat center/cover;`" @click="jumpDetail(item)"></div>
              </swiper-slide>
            </swiper>
            <template v-if="esdxzcData&&esdxzcData.length>3">
              <div class="b swiper-pagination" slot="pagination"></div>
              <div class="b swiper-button-next">
              </div>
              <div class="b swiper-button-prev">
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Custom/Party/Header"
import Footer from "@/components/Custom/Party/Footer"
// import ScreenAdapter from "@/components/ScreenAdapter"
import utils from "../../../../config/utils"
import services from '@/config/services'
import Aside from "../../../../components/Custom/Party/Aside.vue"
export default {
  data () {
    let that = this
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      esdxzcData: [],
      xsdxsxData: [],
      swiperActive: 0,
      swiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        loop: true,
        dynamicBullets: true,
        slidesPerView: 3,
        spaceBetween: 7,
        direction: 'vertical',
        navigation: {
          nextEl: ".t.swiper-button-next",
          prevEl: ".t.swiper-button-prev",
        },
        on: {
          slideChangeTransitionEnd: function () {
            that.swiperActive = this.realIndex
          },
          click: (e) => {
            let id = e.target.getAttribute("data-id")
            window.open(`/center/${that.school_code}/custom/party/detail?id=${id}&key=new`)
          },

        },
      },
      swiperOption2: {
        autoplay: {
          delay: 15000,
          disableOnInteraction: false
        },
        dynamicBullets: true,
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 41,
        pagination: {
          el: ".b.swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".b.swiper-button-next",
          prevEl: ".b.swiper-button-prev",
        },
        // loop: true,
      },

    }
  },
  async mounted () {
    await this.getListData()
    await this.jumpPosition()
  },
  methods: {
    // 跳转到课程详情
    jumpDetail (item, key) {
      window.open(`/center/${this.school_code}/custom/party/detail?id=${item.id}&key=new`, "_blank")
    },
    // 锚点定位
    jumpPosition () {
      let that = this
      let position = that.$route.query.id
      if (position) {
        that.$nextTick(() => {
          let topVal = this.$refs[position].getBoundingClientRect().top
          document.body.scrollTop = topVal - 100
        })
      }
    },
    async getListData () {
      await services.getCourseList({ page: 1, size: 100, category_id: "223", school_code: this.school_code }).then(res => {
        this.xsdxsxData = res.data.items
      })
      await services.getCourseList({ page: 1, size: 100, category_id: "224", school_code: this.school_code }).then(res => {
        this.esdxzcData = res.data.items
      })
    },
  },
  components: {
    Header,
    Footer,
    Aside,
    // ScreenAdapter
  }
}
</script>

<style  lang="less" scoped>
* {
    font-family: Microsoft YaHei;
}
.container {
    width: 1200px;
    margin: 0 auto;
    padding: 0 0 0;

    .content-header {
        width: 100%;
        height: 25px;
        position: relative;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
        background: url('../../../../assets/custom/party/index/list-title.png')
            no-repeat center / cover;
        .text {
            font-size: 42px;
            font-weight: bold;
            background: linear-gradient(180deg, #b70000 70%, #ffcba5 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }
    .content-box {
        position: relative;
        z-index: 10;
    }

    .c-img {
        transition: all 0.7s;
        width: 100%;
        height: 100%;
    }
    .theory-content {
        padding: 76px 18px 54px;
        background: url('../../../../assets/hzvtc/list/top-bg.png') no-repeat
            center/cover;
        height: 715px;
        position: relative;
        &::before {
            content: '';
            display: inline-block;
            width: 100vw;
            height: 100%;
            background: url('../../../../assets/hzvtc/list/center-bg.png')
                no-repeat center/cover;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
        .content-header {
            margin-bottom: 33px;
        }
        .content-box {
            display: flex;
            justify-content: space-between;
            overflow: hidden;
            .show-cover {
                flex-shrink: 0;
                width: 908px;
                height: 510px;
                transition: all 0.7s;
                cursor: pointer;
                overflow: hidden;
                &:hover {
                    .c-img {
                        transform: scale(1.2);
                    }
                }
            }
            .swiper {
                width: 263px;
                height: 510px;
                overflow: hidden;
                padding: 37px 0 37px 0;
                position: relative;
                .swiper-slide {
                    cursor: pointer;
                    margin-left: 11px;
                    // overflow: hidden;
                    width: 100%;
                    height: 100%;
                    &.swiper-slide-active {
                        .img {
                            border: 1px solid #ad1c28;
                            box-shadow: 0px 0px 10px 0px rgba(77, 77, 77, 0.5);
                            &::before {
                                content: '';
                                display: inline-block;
                                width: 14px;
                                height: 141px;
                                background: #b61e2a;
                                position: absolute;
                                top: 50%;
                                left: -12px;
                                transform: translateY(-50%);
                            }
                        }
                    }
                    .img {
                        overflow: hidden;
                        width: 100%;
                        height: 100%;
                        // &.active {
                        //   border: 1px solid #ad1c28;
                        //   box-shadow: 0px 0px 10px 0px rgba(77, 77, 77, 0.5);
                        // }
                        // &.active::before {
                        //   content: '';
                        //   display: inline-block;
                        //   width: 14px;
                        //   height: 141px;
                        //   background: #b61e2a;
                        //   position: absolute;
                        //   top: 50%;
                        //   left: -12px;
                        //   transform: translateY(-50%);
                        // }
                        &:hover {
                            .c-img {
                                transform: scale(1.2);
                            }
                        }
                    }

                    .cover {
                        width: 100%;
                        height: 100%;
                        position: relative;
                        border: 1px solid transparent;
                        transition: all 0.3s;
                    }
                }
                ::v-deep .swiper-container,
                ::v-deep .swiper-container-vertical > .swiper-wrapper {
                    width: 100% !important;
                    height: 100% !important;
                    position: unset !important;
                }
                ::v-deep .swiper-button-prev,
                ::v-deep .swiper-button-next {
                    width: 251px;
                    height: 25px;
                    background: #d5ae7a;
                    border: 1px solid #e3dfde;
                    position: absolute;
                    left: 12px;
                    cursor: pointer;
                    .arrow {
                        width: 16px;
                        height: 9px;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
                ::v-deep .swiper-button-prev {
                    top: 0;
                    .arrow {
                        background: url('../../../../assets/hzvtc/list/arror-up.png')
                            no-repeat center/cover;
                    }
                }
                ::v-deep .swiper-button-next {
                    bottom: 0;
                    .arrow {
                        background: url('../../../../assets/hzvtc/list/arrow-down.png')
                            no-repeat center/cover;
                    }
                }
                ::v-deep .swiper-button-disabled {
                    cursor: not-allowed;
                    opacity: 0.7;
                }
            }
        }
    }

    .history-content {
        margin: 43px 0 72px;
        .content-header {
            margin-bottom: 35px;
        }
        .content-box {
            .swiper {
                position: relative;
                .swiper-slide {
                    width: 380px;
                    height: 214px;
                    overflow: hidden;
                    &:hover {
                        .cover {
                            transform: scale(1.2);
                        }
                    }
                }
                .cover {
                    width: calc(100%);
                    height: 100%;
                    cursor: pointer;
                    transition: all 0.7s;
                }
                ::v-deep .swiper-pagination {
                    margin-top: 24px;
                    display: flex;
                    justify-content: center;
                }
                ::v-deep .swiper-pagination-bullet {
                    width: 10px;
                    height: 10px;
                    background: #cdb29f;
                    border-radius: 50%;
                    display: block;
                    cursor: pointer;
                    &:not(:last-child) {
                        margin-right: 15px;
                    }
                }
                ::v-deep
                    .swiper-pagination-bullet.swiper-pagination-bullet-active {
                    background: #dd3639;
                }
                ::v-deep .swiper-button-next,
                ::v-deep .swiper-button-prev {
                    width: 17px;
                    height: 32px;
                    cursor: pointer;
                    display: block;
                }
                ::v-deep .swiper-wrapper {
                    position: unset !important;
                }
                ::v-deep .swiper-button-prev {
                    background: url('../../../../assets/hzvtc/list/swiper-prev.png')
                        no-repeat center/cover;
                    position: absolute;
                    top: 41%;
                    left: -24px;
                }

                ::v-deep .swiper-button-next {
                    background: url('../../../../assets/hzvtc/list/swiper-next.png')
                        no-repeat center/cover;
                    position: absolute;
                    top: 41%;
                    right: -24px;
                }
            }
        }
    }
}

.fff {
    background: #fff;
}
</style>